// extracted by mini-css-extract-plugin
export default {"page":"CreateTarget_page__EYK50","inputWrapper":"CreateTarget_inputWrapper__zVbGW","content":"CreateTarget_content__WcLcB"};